import type { ReactElement } from 'react';
import type { Theme } from './useTheme.js';

interface ThemeToggleProps {
  readonly theme: Theme;
  readonly onToggle: () => void;
}

export function ThemeToggle({ theme, onToggle }: ThemeToggleProps): ReactElement {
  const isDark = theme === 'dark';
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
  const icon = isDark ? '☀️' : '🌙';
  // S-S154-001: dark-mode-btn--active applied when dark mode is on
  const className = `theme-toggle-btn dark-mode-btn${isDark ? ' dark-mode-btn--active' : ''}`;

  return (
    <button
      className={className}
      data-testid="dark-mode-btn"
      onClick={onToggle}
      aria-label={label}
      title={label}
      type="button"
    >
      {icon}
    </button>
  );
}
